<template>
  <el-tag size="medium" :type="cssClass">
    <filter-icon-by-status :status="status"/>
    {{ statusLabel || "Tất cả" }}
  </el-tag>
</template>

<script>
  import FilterIconByStatus from "../common/filterIconStatusVban";
  import constants from "../../constants";

  export default {
    name: "doc-out-status-tag",
    components: {FilterIconByStatus},
    props: ["status"],

    data() {
      return {
        statusLabel: null,
        cssClass: null
      };
    },

    watch: {
      status() {
        this.initComponent();
      }
    },

    created() {
      this.initComponent();
    },

    methods: {
      initComponent() {
        this.statusLabel = this.getStatusLabel();
        this.cssClass = this.getCssClass();
      },

      getCssClass() {
        switch (this.status) {
          case constants.OUTGOING_DOC_STATUS.TAOMOI:
            return "success";
          case constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH:
            return "warning";
          case constants.OUTGOING_DOC_STATUS.TU_CHOI:
          case constants.OUTGOING_DOC_STATUS.TU_CHOI_BAN_HANH:
            return "danger";
          default:
            return status;
        }
      },

      getStatusLabel() {
        switch (this.status) {
          case constants.OUTGOING_DOC_STATUS.TAOMOI:
            return "Tạo mới";
          case constants.OUTGOING_DOC_STATUS.DABANHANH:
            return "Đã ban hành";
          case constants.OUTGOING_DOC_STATUS.DANGXULI:
            return "Đang trình ký";
          case constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH:
            return "Chờ ban hành";
          case constants.OUTGOING_DOC_STATUS.TU_CHOI:
            return "Đã từ chối";
          case constants.OUTGOING_DOC_STATUS.TU_CHOI_BAN_HANH:
            return "Từ chối ban hành";
          default:
            return status;
        }
      }
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-out/doc-out-status-tag.vue